import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Editor } from '@tinymce/tinymce-react'
import { Grid, Typography, CircularProgress, useTheme } from '@material-ui/core'
import { useStyles } from './EditorGenerico.styles'

export const EditorGenerico = (props) => {
  const { formState, setFormState, processandoExame, exame, campo, tituloCampoTexto } = props
  const editorRef = useRef(null)
  const classes = useStyles()
  const theme = useTheme()
  const isDark = theme.palette.type === 'dark'

  const handleValueChange = (e) => {
    if (editorRef.current) {
      setFormState({
        ...formState,
        values: {
          ...formState.values,
          [campo]: e.target.getContent(),
        },
      })
    }
  }

  return processandoExame ? (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  ) : (
    <Grid>
      {tituloCampoTexto && (
        <Typography className={classes.tituloInputTextoConclusao} variant="h5">
          {tituloCampoTexto}
        </Typography>
      )}
      <div className={classes.editorContainer}>
        <Editor
          key={isDark ? 'dark-editor' : 'light-editor'}
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          licenseKey="gpl"
          // eslint-disable-next-line no-return-assign
          onInit={(_, editor) => (editorRef.current = editor)}
          initialValue={exame[campo] ? exame[campo] : ''}
          onChange={handleValueChange}
          init={{
            setup(ed) {
              ed.on('BeforeSetContent', function e(evt) {
                if (evt.content) {
                  evt.content = evt.content.replace(/<p style=['"]page-break-after:\s*always;?['"]>(?:&nbsp;|\s)*<\/p>/gi, '<p style="page-break-after: always;">&nbsp;</p>')
                }
              })
            },
            style_formats: [
              {
                title: 'Indent',
                selector: 'p',
                styles: { 'text-indent': '30px' },
              },
            ],
            height: 500,
            style_formats_merge: true,
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            pagebreak_separator: '<p style="page-break-after: always;">&nbsp;</p>',
            menubar: false,
            plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount pagebreak'],
            toolbar: 'undo redo | formatselect | table | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist | ' + 'removeformat | help | pagebreak',
            skin: isDark ? 'oxide-dark' : 'oxide',
            content_css: isDark ? 'dark' : 'default',
            content_style: isDark
              ? 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background-color: #282C34; color: #fff; }'
              : 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background-color: #fff; color: #000; }',
          }}
        />
      </div>
    </Grid>
  )
}

EditorGenerico.propTypes = {
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  processandoExame: PropTypes.bool,
  exame: PropTypes.object.isRequired,
  campo: PropTypes.string.isRequired,
  tituloCampoTexto: PropTypes.string,
}

EditorGenerico.defaultProps = {
  processandoExame: false,
  tituloCampoTexto: '',
}
